import React, { useEffect, useState } from "react";
import img_1 from "../../../assets/images/home/pressBlock/company1.png";
import img_2 from "../../../assets/images/home/pressBlock/company2.png";
import img_3 from "../../../assets/images/home/pressBlock/company3.png";
import img_4 from "../../../assets/images/home/pressBlock/company4.png";
import img_5 from "../../../assets/images/home/pressBlock/company5.png";
import img_6 from "../../../assets/images/home/pressBlock/company6.png";
import Right_arraw from "../../../assets/images/Right_arraw.png";
import Slide from "component/common/Slider";
import LeftArray from "../../../assets/images/pressPrevBtn.svg";
import RightArray from "../../../assets/images/pressNxtBtn.svg";
import { GetBlogs } from "service/apis/blogs.apis";
// import moment from "moment";

function slideFun(arr = []) {
  return arr.map((x , index) => {
    return (
      <div className="col-12 py-2" key={index}>
        <div style={{ height: "70px", width: "100px", margin: "auto" }}>
          <img
            src={`${x}`}
            alt=""
            // className=" w-100"
            style={{ width: "100%", objectFit: "contain", height: "100%" }}
          />
        </div>
      </div>
    );
  });
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        // ...style,
        backgroundImage: `url(${RightArray})`,
        backgroundRepeat: "no-repeat",
        right: "3%",
        zIndex: 99,
        backgroundSize: "auto 100%",
      }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        // ...style,
        backgroundImage: `url(${LeftArray})`,
        backgroundRepeat: "no-repeat",
        left: "3%",
        zIndex: 99,
        backgroundSize: "auto 100%",

      }}
      onClick={onClick}
    />
  );
}
let settings = {
  dots: false,
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  rows: 2,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
};

function PressBlk(props) {

  const press = [img_3, img_4, img_1, img_6, img_2, img_5]

  const [blogs, setBlogs] = useState([]);
  //   const [pageInfo, setPageInfo] = useState({});

  useEffect(() => {
    temp();
  }, []);

  async function temp() {
    // console.log("coming");
    // console.log(props, "coming");
    let productInfo = await GetBlogs();

    // console.log(productInfo.articles.edges, "productInfo.articles.edges");
    setBlogs(productInfo.articles.edges);
  }

  return (
    <>
      {/* {console.log(blogs, "bbbbbbbbbb")} */}
      <div id="pressBlock" className="py-sm-5 py-4 px-md-5 px-0">
        <div className="row py-sm-5 m-sm-0 d-block text-center text-sm-left">
          <h5 className="font-weight-bold py-sm-2">In the Press</h5>
          <p className="col-sm-4 col-10 mx-auto mx-sm-0 p-0">
            Small in size yet large in sound, this speaker delivers a clean and
            precise audio experience.
          </p>
          <div className="d-none d-sm-block">
            <img src={img_3} alt="" />
            <img src={img_4} alt="" className="px-sm-3 px-1" />
            <img src={img_1} alt="" className="px-sm-3 px-1" />
            <img src={img_6} alt="" className="px-sm-3 px-1" />
            <img src={img_2} alt="" className="px-sm-3 px-1" />
            <img src={img_5} alt="" className="px-sm-3 px-1" />
          </div>
          <span className="d-block h-100 w-100 d-sm-none py-4 mx-auto">
            <Slide slideData={slideFun(press)} settings={settings} />
          </span>
        </div>
        <div className="row pt-sm-4">
          <div className="col-12">
            <h5 className="font-weight-bold text-center text-sm-left">
              Recent Blogs &amp; Articles
            </h5>
            <div className="row py-4 ">
              {blogs?.slice(0, 3).map((list, i) => (
                <>
                  <div className="col-12 d-flex align-items-stretch mt-4" key={i}>
                    <div className="first">
                      <div className="h-100 d-sm-block d-flex flex-column bg-grey-ee card_c mr-sm-4 mr-3 p-2 pr-0 ">
                        <img src={list?.node?.image?.url} style={{ height: "100%", width: "100px" }} alt='' />
                        {/* <p className="m-0 mt-auto p-0">{moment(list?.node?.publishedAt).format("MMM")}</p>
                      <p className="p mt-0 mb-auto">{moment(list?.node?.publishedAt).format("DD")}</p> */}
                      </div>
                    </div>
                    <div className="px-0 review">
                      <p className="m-0 p-0">{list?.node?.title}</p>
                      {/* <p className="m-0 p-sm-0 py-2">
                      Author: Nazveena Begum, Contributor
                    </p> */}
                      <div
                        dangerouslySetInnerHTML={{
                          __html: list?.node?.contentHtml,
                        }}
                        className="blogsContent col-md-5 col-12 px-0 mb-1"
                      ></div>
                      <button
                        className="btn btn-outline-dark py-1 hand"
                        onClick={() => window.location.assign("/blogs")}
                      >
                        Read Now <img src={Right_arraw} alt="" />
                      </button>
                    </div>
                  </div>
                </>

              ))}
            </div>
            {/* <div className="row border-bottom py-4 d-sm-flex align-items-sm-stretch">
              <div className="col-12 d-flex align-items-stretch">
                <div className="first">
                  <div className="h-100 d-sm-block d-flex flex-column bg-grey-ee card_c mr-sm-4 mr-3 p-2 pr-0 ">
                    <p className="m-0 mt-auto p-0">Jan</p>
                    <p className="p mt-0 mb-auto">26th</p>
                  </div>
                </div>
                <div className="px-0 review">
                  <p className="m-0 p-0">The work from home Toolbox</p>
                  <p className="m-0 p-sm-0 py-2">
                    Author: Nazveena Begum, Contributor
                  </p>
                  <p className="mb-1">
                    Small in size yet large in sound, this speaker delivers a
                    clean and precise audio experience...
                  </p>
                  <button
                    className="btn btn-outline-dark py-1 hand"
                    onClick={() => window.location.assign("/blogs")}
                  >
                    Read Now <img src={Right_arraw} alt="" />
                  </button>
                </div>
              </div>
            </div> */}
            {/* <div className="row py-4 d-sm-flex align-items-sm-stretch">
              <div className="col-12 d-flex align-items-stretch">
                <div className="first">
                  <div className="h-100 d-sm-block d-flex flex-column bg-grey-ee card_c mr-sm-4 mr-3 p-2 pr-0 ">
                    <p className="m-0 mt-auto p-0">Jan</p>
                    <p className="p mt-0 mb-auto">26th</p>
                  </div>
                </div>
                <div className="px-0 review">
                  <p className="m-0 p-0">The work from home Toolbox</p>
                  <p className="m-0 p-sm-0 py-2">
                    Author: Nazveena Begum, Contributor
                  </p>
                  <p className="mb-1">
                    Small in size yet large in sound, this speaker delivers a
                    clean and precise audio experience...
                  </p>
                  <button
                    className="btn btn-outline-dark py-1 hand"
                    onClick={() => window.location.assign("/blogs")}
                  >
                    Read Now <img src={Right_arraw} alt="" />
                  </button>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}

export const PressBlock = PressBlk;
